<ng-container *ngIf="(loading$ | async) === false; else loadingTemplate">
  <p-card>
    <div class="p-fluid lk-eu-mobile-form-fields">
      <div class="field">
        <label class="font-medium required-field">Дата прохода</label>
        <crm-datepicker
          [(value)]="task.date"
          [inputStyleClass]="errors?.date ? 'ng-invalid ng-dirty' : ''"
          appendTo="body"></crm-datepicker>
        <small
          *ngIf="errors?.date"
          class="p-error">
          {{ errors?.date | join }}
        </small>
      </div>

      <div class="field">
        <label class="font-medium required-field">ФИО гостя</label>
        <crm-input-text
          [(value)]="task.name"
          [isError]="$any(errors?.name)"></crm-input-text>
        <small
          *ngIf="errors?.name"
          class="p-error">
          {{ errors.name | join }}
        </small>
      </div>

      <ng-container *ngIf="!(form$ | async)?.isShowDelete">
        <div class="field">
          <label class="font-medium">Повторить проход на следующие дни</label>
          <p-inputNumber
            [(ngModel)]="task.repeat"
            [min]="0"
            suffix=" дн."></p-inputNumber>
          <small
            *ngIf="errors?.repeat"
            class="p-error">
            {{ errors.repeat | join }}
          </small>
        </div>
      </ng-container>
    </div>
  </p-card>

  <div class="mt-3">
    <div class="flex flex-wrap justify-content-between">
      <crm-button
        [label]="saveButtonLabel"
        styleClass="p-button-success"
        (onClick)="saveTask()"></crm-button>
    </div>
  </div>
</ng-container>

<ng-template #loadingTemplate>
  <crm-spinner></crm-spinner>
</ng-template>
